import { useEffect } from "react";


export function ClearAllCookiesAndRedirect() {
    function clearAllCookies() {
        // Get all cookies
        const cookies = document.cookie.split(';');
        
        // Clear each cookie by setting its expiration date to the past
        cookies?.forEach(cookie => {
            const cookieName = cookie.split('=')[0].trim();
            
            // Try to clear the cookie with different domain and path combinations
            const domains = [
                window.location.hostname,
                `.${window.location.hostname}`,
                window.location.hostname.split('.').slice(-2).join('.'),
                `.${window.location.hostname.split('.').slice(-2).join('.')}`
            ];
            
            const paths = ['/', ''];
            
            domains.forEach(domain => {
                paths.forEach(path => {
                    // Try both secure and non-secure versions
                    document.cookie = `${cookieName}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=${path}; domain=${domain}`;
                    document.cookie = `${cookieName}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=${path}; domain=${domain}; secure`;
                
                    console.log("Cleared cookie", cookieName, "with domain", domain, "and path", path)
                });
            });
        });
    }

    useEffect(() => {
        try {
            clearAllCookies();
        } catch (error) {
            console.error("Error clearing cookies", error);
        }

        try {
            localStorage.clear();
        } catch (error) {
            console.error("Error clearing localStorage", error);
        }

        try {
            sessionStorage.clear();
        } catch (error) {
            console.error("Error clearing sessionStorage", error);
        }

        console.log("redirecting to " + "/auth?redirect_to=signup")
        window.location.href = "/auth?redirect_to=signup"
    }, [])
    
    return <></>
}
